/* X-All help center — <xall-faq-hub>: the live filter over the rows, the topic
   chips, the count line, the empty state and deep links. Progressive: without
   this file the chips are a jump nav and the search field posts to the store
   search. Map: docs/design-maps/help-center.md.

   Matching (audit 2026-09-09): a query matches a ROW on its question, answer
   and its own search terms. Topic-level terms are a fallback only: when no row
   anywhere matches, topics whose terms match show all their rows. So "cancel"
   lights the two cancel rows, not every row in two topics. */
(function () {
  if (customElements.get('xall-faq-hub')) return;

  class XallFaqHub extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-x-search]');
      this.form = this.querySelector('[data-x-form]');
      this.search = this.form ? this.form.querySelector('.x-fh__search') || this.form : null;
      this.clear = this.querySelector('[data-x-clear]');
      this.count = this.querySelector('[data-x-count]');
      this.empty = this.querySelector('[data-x-empty]');
      this.strip = this.querySelector('[data-x-strip]');
      this.chips = Array.from(this.querySelectorAll('[data-x-chip]'));
      this.topics = Array.from(this.querySelectorAll('[data-x-topic]'));
      this.rows = Array.from(this.querySelectorAll('[data-x-row]'));
      this.only = 'all';
      this.total = this.rows.length;

      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
      if (this.input) this.input.addEventListener('input', () => {
        const wasEmpty = !this._hadQuery;
        this.apply();
        // phone: the first keystroke pulls the field under the header so the matches
        // land in the half of the screen the keyboard leaves free (audit, 2026-09-09)
        if (wasEmpty && this._hadQuery && window.matchMedia('(max-width: 820px)').matches && this.search) {
          this.search.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      });
      if (this.clear) this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.apply();
        this.announce('All ' + this.total + ' ' + this.dataset.countMany);
        this.input.focus();
      });
      this.chips.forEach((chip) => {
        chip.setAttribute('role', 'button');
        chip.addEventListener('click', (e) => {
          e.preventDefault();
          this.only = chip.dataset.xChip;
          this.chips.forEach((c) => { const on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          this.apply();
        });
      });
      this.querySelectorAll('[data-x-chat]').forEach((a) => a.addEventListener('click', (e) => {
        if (window.zE) { e.preventDefault(); try { window.zE('messenger', 'open'); } catch (err) { /* falls through to mailto */ } }
      }));

      this.deepLink();
      window.addEventListener('hashchange', () => this.deepLink());
    }

    apply() {
      const q = (this.input ? this.input.value : '').trim().toLowerCase();
      const matches = (row) => !q || (row.dataset.xQ || '').indexOf(q) !== -1;
      const inTopic = (topic) => this.only === 'all' || topic.dataset.xTopic === this.only;

      // pass 1: rows on their own text
      let shown = 0;
      const perTopic = this.topics.map((topic) => {
        const rows = Array.from(topic.querySelectorAll('[data-x-row]'));
        const hits = inTopic(topic) ? rows.filter(matches) : [];
        shown += hits.length;
        return { topic, rows, hits };
      });
      // pass 2: nothing matched a row, so fall back to topic-level terms
      if (q && shown === 0) {
        perTopic.forEach((t) => {
          if (inTopic(t.topic) && (t.topic.dataset.xTerms || '').indexOf(q) !== -1) { t.hits = t.rows; shown += t.rows.length; }
        });
      }
      perTopic.forEach((t) => {
        t.rows.forEach((row) => { row.hidden = t.hits.indexOf(row) === -1; });
        t.topic.hidden = t.hits.length === 0;
        const blurb = t.topic.querySelector('[data-x-blurb]');
        if (blurb) blurb.hidden = !!q;
      });

      if (this.empty) this.empty.hidden = shown !== 0;
      if (this.clear) this.clear.hidden = !q;
      if (this.search) this.search.classList.toggle('has-q', !!q);
      if (this.strip) this.strip.hidden = !!q;
      this.classList.toggle('is-searching', !!q);
      this._hadQuery = !!q;
      if (this.count) {
        const active = q || this.only !== 'all';
        this.count.textContent = active ? shown + ' ' + (shown === 1 ? this.dataset.countOne : this.dataset.countMany) : '';
      }
    }

    announce(text) {
      if (!this.count) return;
      this.count.textContent = text;
      clearTimeout(this._t);
      this._t = setTimeout(() => { if (this.count.textContent === text) this.count.textContent = ''; }, 1500);
    }

    deepLink() {
      const id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      const el = document.getElementById(id);
      if (!el || !this.contains(el)) return;
      if (el.tagName === 'DETAILS') {
        el.open = true;
        const summary = el.querySelector('summary');
        requestAnimationFrame(() => {
          el.scrollIntoView({ block: 'start' });
          if (summary) summary.focus({ preventScroll: true });
        });
      }
    }
  }

  customElements.define('xall-faq-hub', XallFaqHub);
})();
